import { colors } from "@murm/charts";

/**
 * Data-viz colors from @murm/charts that also appear outside the charts (TrueViews badges, the
 * support/oppose text tint, the Early Vote comparison picker). Ant's cssVar only emits theme
 * tokens, so these are published once as CSS variables on :root and CSS modules read them --
 * the values stay owned by @murm/charts instead of being copied into stylesheets.
 */
export const CHART_COLOR_VARS = {
  "--murm-chart-district-badge-bg": colors.districtBadge.background,
  "--murm-chart-district-badge-text": colors.districtBadge.text,
  "--murm-chart-comparison-badge-bg": colors.comparisonBadge.background,
  "--murm-chart-comparison-badge-text": colors.comparisonBadge.text,
  "--murm-chart-support": colors.chartColors.support,
  "--murm-chart-oppose": colors.chartColors.oppose,
  "--murm-chart-secondary": colors.chartColors.secondary,
  "--murm-chart-preset-comparison": colors.mviolet["300"],
  "--murm-chart-no-comparison": colors.morange.default,
};

export function applyChartColorVars(root = document.documentElement) {
  for (const [name, value] of Object.entries(CHART_COLOR_VARS)) {
    root.style.setProperty(name, value);
  }
}
